import React from 'react';
import Welcome from '../../components/Welcome';

const Homepage = props => {
  return (
    <>
      <Welcome />
    </>
  );
};

export default Homepage;